import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SurveyPage from "./pages/Surveys/Surveys";
import NotFound from "./pages/NotFound/NotFound";
import Unsubscribe from "./pages/Unsubscribe/Unsubscribe";
import ColexitRedirectPage from "./pages/Consent/ColexitRedirectPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/Survey/:userGuid/:surveyGuid" element={<SurveyPage />} />
        <Route path="/RedirectToColexit/:userGuid/:surveyGuid" element={<ColexitRedirectPage />} />
        <Route path="/Unsubscribe/:userGuid" element={<Unsubscribe />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
